<div class="ib-pmt-tab-mark-new">
  <p class="ib-pmt-tab-mark-new__container">
    <span class="ib-pmt-tab-mark-new__heading">{{'PAYMENTS_TAB_NEW'|translate}}</span>
  </p>
</div>